<template>
  <div class="modal__content">
    <p class="text-center mb20">Are you sure you want to remove comment from this design?</p>

    <div class="flex flex--justify-center">
      <button class="btn btn--wide btn--gray-2 mr10" @click="$bus.$emit('modalClose')" type="button">No</button>
      <button class="btn btn--wide" @click="onConfirm">Yes</button>
    </div>

    <app-loader ref="loader" class="loader-overlay--inside loader-overlay--radius"></app-loader>
  </div>
</template>

<script>
  import AppLoader from 'components/common/Loader'
  export default {

    props: ['args'],

    data () {
      return {

      }
    },

    components: {
      'app-loader': AppLoader
    },

    methods: {
      onConfirm () {
        this.onLoaderShow()
        this.$bus.$emit('removeComment', this.args.currentFile.uuid, this.args.comment, this.args.commentReply)
      },

      onLoaderShow () {
        this.$refs.loader.onShow()
      },

      onLoaderClose () {
        this.$refs.loader.onClose()
      }

    }
  }
</script>



// WEBPACK FOOTER //
// GalleryRemoveCommentModal.vue?4b06b54e